import { render } from "./CadastrarImovel.vue?vue&type=template&id=2bfd645c"
import script from "./CadastrarImovel.vue?vue&type=script&lang=js"
export * from "./CadastrarImovel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__